import { defineStore } from 'pinia'
import { getRadioStatus, getHours, brHour } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'

export const useStore = defineStore('store', {
  state: () => ({
    initSite: {
      color1: '',
      color2: '',
      logo: '',
      header: '',
      logo_footer: '',
      favicon: '',
      onSearch: '',
      maintenance: 0,
      clouds: false
    },
    initUser: {},
    hasPanelAccess: false,
    dev: false,
    logged: false,
    valCart: [],
    valCartView: [],
    textA: '',
    radio: {
      playing: true,
      name: '',
      programa: '',
      ouvintes: 0,
      volume: 60,
      proximo: '',
      liked: false,
    },
    audio: '',
    modRd: false,
    schedule: {
      hours: [],
      hours2: [],
      loaded: false,
    },
  }),

  getters: {
    totalValCalc: (state) => () => {
      let sm = 0
      for (const e of state.valCart) {
        sm = (e.item.preco * e.quantity) + sm
      }
      return sm
    },
    qtyVal: (state) => (id) => {
      let foundCount = 0
      for (const v of state.valCart) {
        if (Number(v.id) === Number(id)) foundCount++
      }
      return foundCount
    }
  },

  actions: {
    storeUser(data) {
      this.initUser = data.user ?? data
      this.logged = data.logged
      if (!data.logged) this.hasPanelAccess = false
    },

    storePanelAccess(val) {
      this.hasPanelAccess = !!val
    },

    storeSite(data) {
      this.initSite = { ...this.initSite, ...data }
    },

    storePlay(p) {
      this.radio.playing = p
      trackEvent(p ? 'radio_play' : 'radio_pause')
      if (!this.audio?.volume && this.audio?.volume !== 0) return
      if (p) {
        this.audio.volume = 0.5
        this.radio.volume = 50
      } else {
        this.audio.volume = 0
        this.radio.volume = 0
      }
    },

    storeVolume(v) {
      if (!this.audio?.volume && this.audio?.volume !== 0) return
      this.audio.volume = v
      this.radio.volume = v * 100
    },

    addCalc(data) {
      const idx = this.valCart.findIndex((i) => i.item.id == data.data.id)
      if (idx === -1) {
        let f = data.qty == 1 ? 1 : data.qty
        this.valCart.push({ item: data.data, quantity: f })
      } else {
        let f = (this.valCart[idx].quantity * data.qty) + 1
        if (f >= 0) this.valCart[idx].quantity = f
      }
    },

    removeCalc(data) {
      const idx = this.valCart.findIndex((i) => i.item.id == data.id)
      let f = (this.valCart[idx].quantity * data.qty) - 1
      if (f >= 0) this.valCart[idx].quantity = f
    },

    removeItemCalc(data) {
      this.valCart.splice(data, 1)
    },

    clearVal() {
      this.valCart = []
    },

    Alert(text) {
      this.textA = text
      setTimeout(() => {
        this.textA = ''
      }, 3500)
    },

    async loadSchedule() {
      try {
        const data = await getHours()
        this.schedule.hours  = data.hours ?? []
        this.schedule.hours2 = data.hours2 ?? []
        this.schedule.loaded = true

        // Deriva próximo locutor do schedule
        const next = this.schedule.hours[1]
        this.radio.proximo = (next && !next.isAutoDJ) ? next.user : 'BletDJ'
      } catch (_) {
        // schedule é opcional
      }
    },

    async player() {
      if (import.meta.env.SSR) return
      try {
        const data = await getRadioStatus()
        this.radio.name     = data.locutor ?? ''
        this.radio.programa = data.programa ?? ''
        this.radio.ouvintes = data.ouvintes ?? 0
        this.radio.liked    = data.locLike ?? false
        // schedule sempre atualizado junto com o status
        await this.loadSchedule()
        // proximo sempre vem do schedule interno (loadSchedule), nunca da API externa

        if (data.ip && data.port) {
          const src = `https://${data.ip}/${data.port}/stream`
          if (!this.audio?.src || this.audio.src !== src) {
            if (this.audio?.pause) this.audio.pause()
            this.audio = new Audio(src)
          }
          this.audio.volume = this.radio.volume / 100

          this.audio.addEventListener('canplaythrough', () => {
            this.audio.play().catch(() => {
              window.addEventListener('click', () => {
                this.audio.play()
              }, { once: true })
            })
          }, { once: true })
        }
      } catch (_) {
        // status de rádio é opcional
      }
    }
  }
})
